"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelSkillsStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
exports.PanelSkillsStyled = styled.div `
&.octo {
  >.category {
    display: flex;
    flex-flow: column nowrap;
    gap: 1em;
    align-items: stretch;
    justify-content: stretch;
    break-inside: avoid-column;

    >.title {
      display: flex;
      flex-flow: row;
      padding: 0.5em 0;
      border-bottom: 0.0625em solid ${design_system_1.theme.colors.marine[70]};
      font-weight: bold;

      >span:first-child {
        width: 34em;
      }

      >span:nth-child(2) {
        margin-right: 3.5em;
      }
    }

    >.skills {
      display: flex;
      flex-flow: column nowrap;
      gap: 0.5em;
      align-items: stretch;
      justify-content: stretch;

      > button.skill {
        cursor: pointer;

        &:hover {
          font-weight: 600;
        }
      }
    }

    &:not(:first-child) {
      margin-top: 1em;
    }
  }
}
`;
//# sourceMappingURL=PanelSkills.styled.js.map